import Vue from 'vue'
import draggable from 'vuedraggable'
import {StylesParser} from '../StylesParser'
import {ConstantsParser} from '../ConstantsParser'
export default Vue.extend({
  components: {draggable},
  data() {
    return {
      childHover: false,
      hover: false,
    }
  },
  watch: {
    hover(value) {
      value ? this.$emit('mouseover') : this.$emit('mouseleave')
    }
  },
  computed: {
    name() {
      return this.$store.getters[`${this.module}/name`](this.element, this.parentModule)
    },
    id() {
      return this.$vnode.key
    },
    element() {
      let element = {
        pageComponent: this.pageComponentIndex,
        section: this.sectionIndex,
        row: this.rowIndex,
        column: this.columnIndex,
        component: this.componentIndex,
        componentSection: this.componentSectionIndex,
        componentRow: this.componentRowIndex,
        componentColumn: this.componentColumnIndex,
        componentComponent: this.componentComponentIndex,
      }
      if (this.parentModule == 'layoutPageComponentModule') {
        element = {
          layoutPageComponent: this.pageComponentIndex,
          componentSection: this.componentSectionIndex,
          componentRow: this.componentRowIndex,
          componentColumn: this.componentColumnIndex,
          componentComponent: this.componentComponentIndex,
        }
      }
      let newElement = Object.keys(element)
        .filter(key => element[key] != null)
        .reduce((obj, key) => {
            obj[key] = element[key]
            return obj
        }, new Object)
      return newElement
  },
    menuOptions() {
      return window.config.menu[this.module]
    },
    previewMode() {
      return this.$store.state.previewMode
    },
    editorClasses() {
      if (this.previewMode) {
          return []
      }
      let classes = ['wf-relative', 'wf-border', 'wf-py-4']
      if (this.hover && ! this.childHover) {
          classes.push('wf-border-blue-300')
      } else {
        classes.push('wf-border-transparent')
      }
      return classes
    },
    device() {
      return this.$store.getters['pageModule/device']
    },
    elementContainerClasses() {
      return (new ConstantsParser(this.containerClasses, this.device)).parse()
    },
    elementClasses() {
      let classes = (new ConstantsParser(this.classes, this.device)).parse()
      return [...this.constantClasses, ...this.customClasses, ...classes]
    },
    elementStyles() {
      return (new StylesParser(this.styles, this.device)).parse()
    },
    customClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'customClasses')
    },
    constantClasses() {
      return []
    }
  }
})